<template>
    <div :id="id" class="popup order__popup js-delivery-popup">
        <div class="order__scroll">
            <div class="order__popup-header order__subtitle cart__subtitle">
                Что включено в услугу «Доставка и настройка»
                <i class="popup__close arcticmodal-close" @click="close()"></i>
            </div>
            <div class="cart">
                <div class="delivery" v-html="body"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalComponent",
    props: {
        id: {
            type: String,
        },
        body: {
            type: String,
        },
    },
    methods: {
        close () {
            this.$emit('close');
        },
    },
}
</script>